import { useQuery } from '@tanstack/react-query';

import { fetchBuildings, fetchBuilding } from './warehouseApi.js';

export function useBuildings() {
  return useQuery({
    queryKey: ['warehouse', 'buildings'],
    queryFn: fetchBuildings,
    staleTime: 60_000,
  });
}

export function useBuilding(buildingId) {
  return useQuery({
    queryKey: ['warehouse', 'building', buildingId],
    queryFn: () => fetchBuilding(buildingId),
    enabled: !!buildingId,
    staleTime: 60_000,
  });
}
